import { render, staticRenderFns } from "./OrgInfo.vue?vue&type=template&id=264c7476&scoped=true&"
import script from "./OrgInfo.vue?vue&type=script&lang=js&"
export * from "./OrgInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c7476",
  null
  
)

export default component.exports